/* BONODER — ajout au panier : interception des formulaires + filet anti-doublon.

   Deux protections independantes :
   1) l'interception ne renvoie JAMAIS le formulaire en natif apres un envoi.
      L'ancienne version le faisait des que la reponse posait probleme, meme si
      l'article etait deja au panier : un ajout reussi suivi d'un JSON illisible
      donnait donc deux exemplaires.
   2) un filtre au niveau reseau refuse tout POST /cart/add strictement identique
      envoye moins de 1,5 s apres le precedent, quelle que soit son origine
      (theme, application, extension). C'est le filet de securite : meme si le
      doublon vient d'une app, il n'atteint plus le panier. */
(function () {
  'use strict';

  if (document.documentElement.dataset.bdDrawerForms === '1') return;
  document.documentElement.dataset.bdDrawerForms = '1';

  var WINDOW_MS = 1500;
  var lastAdd = { key: '', at: 0 };
  var IGNORED = { utf8: 1, form_type: 1, 'section-id': 1, sections: 1, sections_url: 1 };

  function pathOf(u) {
    var s = String(u || '');
    var i = s.indexOf('://');
    if (i > -1) {
      var j = s.indexOf('/', i + 3);
      s = j > -1 ? s.slice(j) : '/';
    }
    s = s.split('?')[0].split('#')[0];
    if (s.length > 1 && s.charAt(s.length - 1) === '/') s = s.slice(0, -1);
    return s;
  }

  function isAddPath(u) {
    var p = pathOf(u);
    return p === '/cart/add' || p === '/cart/add.js';
  }

  function bodyKey(body) {
    try {
      if (!body) return 'vide';
      if (typeof body === 'string') return body.slice(0, 400);
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var parts = [];
        body.forEach(function (v, k) { if (!IGNORED[k]) parts.push(k + '=' + String(v)); });
        return parts.sort().join('&').slice(0, 400);
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.toString().slice(0, 400);
      return 'autre';
    } catch (e) { return 'illisible'; }
  }

  function isDuplicate(body) {
    var key = bodyKey(body);
    var now = Date.now();
    if (key === lastAdd.key && now - lastAdd.at < WINDOW_MS) {
      try { console.warn('[BONODER] ajout au panier en double ignore :', key); } catch (e) {}
      return true;
    }
    lastAdd.key = key;
    lastAdd.at = now;
    return false;
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function' && !origFetch.__bdDedupe) {
    var wrapped = function (input, init) {
      try {
        var url = (input && input.url) || String(input);
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && isAddPath(url) && isDuplicate(init && init.body)) {
          return origFetch.call(window, '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        }
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
    wrapped.__bdDedupe = true;
    window.fetch = wrapped;
  }

  var origOpen = XMLHttpRequest.prototype.open;
  if (!origOpen.__bdDedupe) {
    var newOpen = function (method, url) {
      this.__bdAdd = String(method || '').toUpperCase() === 'POST' && isAddPath(url);
      return origOpen.apply(this, arguments);
    };
    newOpen.__bdDedupe = true;
    XMLHttpRequest.prototype.open = newOpen;

    var origSend = XMLHttpRequest.prototype.send;
    var newSend = function (body) {
      if (this.__bdAdd && isDuplicate(body)) return;
      return origSend.apply(this, arguments);
    };
    newSend.__bdDedupe = true;
    XMLHttpRequest.prototype.send = newSend;
  }

  var inFlight = new WeakSet();

  function isBuyNow(sub) {
    if (!sub) return false;
    if (sub.name === 'checkout') return true;
    return !!(sub.closest && sub.closest('.shopify-payment-button, [data-shopify="payment-button"]'));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.hasAttribute('data-bdd-ignore')) return;
    if (pathOf(form.getAttribute('action')) !== '/cart/add') return;
    if (isBuyNow(e.submitter)) return;
    if (form.classList.contains('installment')) return;
    if (e.defaultPrevented) return;

    e.preventDefault();

    if (inFlight.has(form)) return;
    inFlight.add(form);

    var btn = e.submitter || form.querySelector('[type="submit"], [name="add"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var release = function () {
      inFlight.delete(form);
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    };

    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (r && r.ok && window.bdCartDrawer) window.bdCartDrawer.open();
      })
      .catch(function () {})
      .then(release, release);
  }, true);
})();